<template>
    <div class="axios chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.radiusAxis.show" @change="getRender">是否显示径向轴</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.radiusAxis.axisLine.show" @change="getRender">是否显示径向轴轴线</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">轴线颜色</span>
            <el-color-picker v-model="config.radiusAxis.axisLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.radiusAxis.axisLabel.show" @change="getRender">是否显示径向轴文字</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.radiusAxis.axisLabel.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.radiusAxis.axisLabel.fontSize" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体角度</span>
            <el-input v-model="config.radiusAxis.axisLabel.rotate" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.radiusAxis.axisTick.show" @change="getRender">是否显示径向轴刻度</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.radiusAxis.splitLine.show" @change="getRender">是否显示分隔线</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">分隔线颜色</span>
            <el-color-picker v-model="config.radiusAxis.splitLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">分隔线宽度</span>
            <el-input v-model="config.radiusAxis.splitLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:58 下午
     */
    export default {
        name: 'axios',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                typeList:[
                    {value: 'category', label: '类目轴'},
                    {value: 'value', label: '数值轴'},
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .axios {
        .chartDivConfig {
            .span_til {
                width: 32%!important;
                max-width: 90px !important;
            }
        }
    }
</style>